import { shape, string, number, objectOf, arrayOf, boolean } from '@dtvgo/typed-normalizr';
import { convertImagesArrayToObject } from './utils.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';
import '@dtvgo/constants';
import './constants.js';

const Image = shape({
  ratio: string(),
  height: number(),
  type: string(),
  url: string(),
  width: number()
});
const ImagesCollection = objectOf(Image);
const WithImages = {
  images: ImagesCollection
};
const Streaming = {
  streaming: shape({
    id: string(),
    provider: string()
  })
};
const WithPrimaryBackupAndLLURLs = {
  primary: string(),
  backup: string(),
  lowLatency: string()
};
const URLsObject = {
  dash: shape(WithPrimaryBackupAndLLURLs),
  hls: shape(WithPrimaryBackupAndLLURLs),
  smooth: shape(WithPrimaryBackupAndLLURLs)
};
const WithCertificateAndLicenseURLs = {
  certificateUrl: string(),
  licenseUrl: string(),
  quality: string()
};
const DRMSObject = {
  fairplay: arrayOf(shape(WithCertificateAndLicenseURLs)),
  playready: arrayOf(shape(WithCertificateAndLicenseURLs)),
  widevine: arrayOf(shape(WithCertificateAndLicenseURLs))
};
const Team = shape(
  {
    images: ImagesCollection,
    optaTeamId: string(),
    fifaTeamId: string(),
    name: string()
  },
  // Predeserialize team
  convertImagesArrayToObject
);
const Scores = shape({
  regularPoints: number(),
  extraPoints: number()
});
const MatchTeam = shape({
  team: Team,
  isWinner: boolean(),
  scores: Scores
});

export { DRMSObject, Image, ImagesCollection, MatchTeam, Scores, Streaming, Team, URLsObject, WithImages };
//# sourceMappingURL=interfaces.js.map
